<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Manutenção/Ordem Serviço</label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col  cols="12" sm="2">
          <v-btn
            color="info"
            to="/ordemServico/criar"
            v-if="isAllowed(idModulo)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="0">
              <template v-slot:label>
                <v-avatar size="25" color="primary">
                  <span class="white--text text-h6">TD</span>
                </v-avatar>
                <div class="ma-1 text-h5">Todas</div>
              </template></v-radio
            ><v-radio value="EA">
              <template v-slot:label>
                <v-avatar size="25" color="red">
                  <span class="white--text text-h6">EA</span>
                </v-avatar>
                <div class="ma-1 text-h5">Em Aberto</div>
              </template>
            </v-radio>
            <v-radio value="AA">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">AA</span>
                </v-avatar>
                <div class="ma-1 text-h5">Aguardando Autorizacao</div>
              </template>
            </v-radio>
            <v-radio value="B">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">B</span>
                </v-avatar>
                <div class="ma-1 text-h5">Baixada</div>
              </template>
            </v-radio>
            <v-radio value="I">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">I</span>
                </v-avatar>
                <div class="ma-1 text-h5">Inativa</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col class="text-right" cols="12" sm="2">
          <v-btn
            @click="baixarlista()"
            v-if="ordensServico.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="right">
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataIni"
                label="Data inicio"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate1"
                @click:clear="dataIni = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataIni"
              @input="menuData1 = false"
              @change="dateChangeDataIni"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataFim"
                label="Data fim"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate2"
                @click:clear="dataFim = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFim"
              @input="menuData2 = false"
              @change="dateChangeDataFim"
              locale="pt-br"
              forma
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title class="ordem-servico-lista__titulo">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
        <v-tooltip v-if="!isMobileLayout" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              class="ml-4 ordem-servico-lista__restaurar-colunas"
              @click="restaurarColunasOrdemServico"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left small>mdi-table-column-width</v-icon>
              Restaurar colunas
            </v-btn>
          </template>
          <span>Restaurar larguras padr\u00e3o</span>
        </v-tooltip>
      </v-card-title>

      <v-data-table
        v-if="!isMobileLayout"
        v-resizable-columns="resizableColumnsOptions"
        :headers="headersAtuais"
        :items="filteredList"
        :loading="loading"
        loading-text="Buscando dados..."
        :options.sync="options"
        :footer-props="footerProps"
        :show-expand="isTabelaCompacta"
        :single-expand="true"
        :expanded.sync="expanded"
        item-key="id"
        class="ordem-servico-table"
      >
        <template v-slot:item.id="{ item }">
          <span class="cell-nowrap">{{ item.id }}</span>
        </template>
        <template v-slot:item.idChamado="{ item }">
          <span class="cell-nowrap">{{ formatarValor(item.idChamado) }}</span>
        </template>
        <template v-slot:item.dataInicial="{ item }">
          <div class="os-data-hora">
            <span class="os-data">{{ formatarData(item.dataInicial) }}</span>
            <span class="os-hora">{{ formatarHora(item.horaInicial || item.dataInicial) }}</span>
          </div>
        </template>
        <template v-slot:item.dataFinal="{ item }">
          <div v-if="formatarData(item.dataFinal)" class="os-data-hora">
            <span class="os-data">{{ formatarData(item.dataFinal) }}</span>
            <span class="os-hora">{{ formatarHora(item.horaFinal || item.dataFinal) }}</span>
          </div>
          <span v-else class="cell-nowrap">-</span>
        </template>
        <template v-slot:item.tempo="{ item }">
          <span class="cell-nowrap">{{ formatarValor(item.tempo) }}</span>
        </template>
        <template v-slot:item.unidadeAdm="{ item }">
          <span class="cell-texto">{{ item.unidadeAdm }}</span>
        </template>
        <template v-slot:item.editor="{ item }">
          <span class="cell-texto">{{ (item.editor || item.usuario) }}</span>
        </template>
        <template v-slot:item.mecanico="{ item }">
          <span class="cell-texto">{{ formatarMecanico(item) }}</span>
        </template>
        <template v-slot:item.tipoOS="{ item }">
          <span class="cell-texto">{{ formatarTipoOS(item.tipoOS) }}</span>
        </template>
        <template v-slot:item.equipamento="{ item }">
          <span class="cell-texto">{{ item.equipamento }}</span>
        </template>
        <template v-slot:item.status="{ item }">
          <span class="status-cell">
            <v-avatar :color="statusColor(item.status)" size="24">
              <span class="white--text text-h5">{{ statusLabel(item.status) }}</span>
            </v-avatar>
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="acoes-cell">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="acoes-icon"
                  @click="show(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-file-search
                </v-icon>
              </template>
              <span>Visualizar em PDF</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="acoes-icon"
                  @click="editar(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span v-if="isAllowed(idModulo)">Editar</span>
              <span v-else>Ver</span>
            </v-tooltip>
            <v-tooltip v-if="isInactive(idModulo)" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="error"
                  class="acoes-icon"
                  @click="inativar(item)"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!ordemServicoPodeSerInativada(item)"
                >
                  mdi-close-thick
                </v-icon>
              </template>
              <span>Inativar</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="os-expanded-cell">
            <div class="os-expanded-grid">
              <div class="os-detail-item">
                <span>Chamado</span>
                <strong>{{ formatarValor(item.idChamado) }}</strong>
              </div>
              <div class="os-detail-item">
                <span>Tempo da OS</span>
                <strong>{{ formatarValor(item.tempo) }}</strong>
              </div>
              <div class="os-detail-item">
                <span>Responsável</span>
                <strong>{{ formatarValor(item.editor || item.usuario) }}</strong>
              </div>
              <div class="os-detail-item">
                <span>Mecânico</span>
                <strong>{{ formatarValor(formatarMecanico(item)) }}</strong>
              </div>
              <div class="os-detail-item">
                <span>Tipo</span>
                <strong>{{ formatarValor(formatarTipoOS(item.tipoOS)) }}</strong>
              </div>
              <div class="os-detail-item">
                <span>Ativo</span>
                <strong>{{ formatarAtivo(item) }}</strong>
              </div>
            </div>
          </td>
        </template>
      </v-data-table>

      <div v-else class="os-mobile-list">
        <v-card
          v-for="item in itemsPaginadosMobile"
          :key="item.id"
          class="os-mobile-card"
          outlined
        >
          <v-card-title class="os-mobile-card__header">
            <div class="os-mobile-title">
              <span>OS</span>
              <strong>{{ item.id }}</strong>
            </div>
            <div class="os-mobile-status">
              <v-avatar :color="statusColor(item.status)" size="28">
                <span class="white--text text-h6">{{ statusLabel(item.status) }}</span>
              </v-avatar>
              <span>{{ formatarAtivo(item) }}</span>
            </div>
          </v-card-title>

          <v-card-text class="os-mobile-body">
            <div class="os-mobile-field">
              <span>Início</span>
              <strong>{{ formatarDataHora(item.dataInicial, item.horaInicial) }}</strong>
            </div>
            <div class="os-mobile-field">
              <span>Fim</span>
              <strong>{{ formatarValor(formatarDataHora(item.dataFinal, item.horaFinal)) }}</strong>
            </div>
            <div class="os-mobile-field">
              <span>Unidade</span>
              <strong>{{ formatarValor(item.unidadeAdm) }}</strong>
            </div>
            <div class="os-mobile-field">
              <span>Equipamento</span>
              <strong>{{ formatarValor(item.equipamento) }}</strong>
            </div>
            <div class="os-mobile-field">
              <span>Tipo</span>
              <strong>{{ formatarValor(formatarTipoOS(item.tipoOS)) }}</strong>
            </div>

            <v-btn
              text
              small
              color="primary"
              class="os-mobile-details-btn"
              :aria-expanded="detalhesMobileAbertos === item.id ? 'true' : 'false'"
              @click="alternarDetalhesMobile(item.id)"
            >
              {{ detalhesMobileAbertos === item.id ? "Ocultar detalhes" : "Ver detalhes" }}
            </v-btn>

            <v-expand-transition>
              <div
                v-show="detalhesMobileAbertos === item.id"
                class="os-mobile-details"
              >
                <div class="os-mobile-field">
                  <span>Chamado</span>
                  <strong>{{ formatarValor(item.idChamado) }}</strong>
                </div>
                <div class="os-mobile-field">
                  <span>Tempo</span>
                  <strong>{{ formatarValor(item.tempo) }}</strong>
                </div>
                <div class="os-mobile-field">
                  <span>Responsável</span>
                  <strong>{{ formatarValor(item.editor || item.usuario) }}</strong>
                </div>
                <div class="os-mobile-field">
                  <span>Mecânico</span>
                  <strong>{{ formatarValor(formatarMecanico(item)) }}</strong>
                </div>
              </div>
            </v-expand-transition>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="os-mobile-actions">
            <v-btn
              text
              small
              color="primary"
              aria-label="Visualizar em PDF"
              @click="show(item)"
            >
              <v-icon left small>mdi-file-search</v-icon>
              PDF
            </v-btn>
            <v-btn
              text
              small
              color="primary"
              :aria-label="isAllowed(idModulo) ? 'Editar ordem de serviço' : 'Ver ordem de serviço'"
              @click="editar(item)"
            >
              <v-icon left small>mdi-pencil</v-icon>
              {{ isAllowed(idModulo) ? "Editar" : "Ver" }}
            </v-btn>
            <v-btn
              v-if="isInactive(idModulo)"
              text
              small
              color="error"
              aria-label="Inativar ordem de serviço"
              :disabled="!ordemServicoPodeSerInativada(item)"
              @click="inativar(item)"
            >
              <v-icon left small>mdi-close-thick</v-icon>
              Inativar
            </v-btn>
          </v-card-actions>
        </v-card>

        <div v-if="!loading && itemsPaginadosMobile.length === 0" class="os-mobile-empty">
          Nenhum registro encontrado
        </div>

        <div class="os-mobile-pagination">
          <v-select
            :value="options.itemsPerPage"
            :items="itensPorPaginaOptions"
            item-text="text"
            item-value="value"
            label="Itens por página"
            dense
            outlined
            hide-details
            class="os-mobile-per-page"
            @change="alterarItensPorPagina"
          ></v-select>
          <v-pagination
            :value="paginaMobileAtual"
            :length="totalPaginasMobile"
            :total-visible="5"
            @input="alterarPaginaMobile"
          ></v-pagination>
        </div>
      </div>
    </v-card>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">Inativar Ordem de Serviço</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form2" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12"
                  ><v-subheader
                    ><strong
                      >Deseja realmente Inativar a OS: {{ item ? item.id : "" }}?</strong
                    ></v-subheader
                  >
                  <hr />
                  <v-textarea
                    label="Se sim justifique o motivo..."
                    v-model="justificativa"
                    clear-icon="mdi-close-circle"
                    :rules="[(v) => !!v || 'A justificativa é obrigatória']"
                    required
                    rows="2"
                    auto-grow
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
            <v-row align="center-left">
              <v-col class="text-right">
                <v-btn @click="fecharModal()" color="error" class="mr-4">
                  Voltar
                </v-btn>
                <v-btn @click="realizarInativacao()" color="success" class="mr-4">
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  getPdf,
  inativarOrdemServicoAsync,
} from "../../../services/ordemServicoService";
import moment from "moment";
import { canInactivateModule, getUserRoles } from "@/services/loginService";
import { abrirJanelaPdf } from "@/services/pdfHelper";
import { saveAs } from "file-saver";

export default {
  name: "listaOrdensServico",
  data() {
    return {
      idModulo: 17,
      overlay: false,
      loading: false,
      search: "",
      valid: true,
      selectedFilter: "0",
      showAtivo: false,
      item: null,
      showModal: false,
      justificativa: null,
      dataIni: null,
      dataFim: null,
      menuData1: false,
      menuData2: false,
      active_tab: 2,
      expanded: [],
      detalhesMobileAbertos: null,
      columnResizeResetKey: 0,
      itensPorPaginaOptions: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "15", value: 15 },
        { text: "Todos", value: -1 },
      ],
      filters: {
        idChamado: [],
        unidadeAdm: [],
        dataInicial: [],
        dataFinal: [],
        equipamento: [],
        usuario: [],
        mecanico: [],
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
    };
  },
  computed: {
    footerProps() {
      return {
        showFirstLastPage: true,
        itemsPerPageText: "Items por página",
        itemsPerPageOptions: [5, 10, 15, -1],
      };
    },
    headersDesktop() {
      return [
        { text: "OS", align: "start", value: "id", width: "4%", minWidth: 55, class: "col-os", cellClass: "col-os" },
        { text: "Chamado", value: "idChamado", width: "5%", minWidth: 65, class: "col-chamado", cellClass: "col-chamado" },
        { text: "In\u00edcio", value: "dataInicial", width: "6%", minWidth: 86, class: "col-data", cellClass: "col-data" },
        { text: "Fim", value: "dataFinal", width: "6%", minWidth: 86, class: "col-data", cellClass: "col-data" },
        { text: "Tempo", value: "tempo", width: "6%", minWidth: 70, class: "col-tempo", cellClass: "col-tempo" },
        { text: "Unidade", value: "unidadeAdm", width: "10%", minWidth: 100, class: "col-texto", cellClass: "col-texto" },
        { text: "Responsável", value: "editor", width: "9%", minWidth: 110, class: "col-texto", cellClass: "col-texto" },
        { text: "Mec\u00e2nico", value: "mecanico", width: "9%", minWidth: 100, class: "col-texto", cellClass: "col-texto" },
        { text: "Tipo", value: "tipoOS", width: "7%", minWidth: 80, class: "col-texto", cellClass: "col-texto" },
        { text: "Equipamento", value: "equipamento", width: "12%", minWidth: 120, class: "col-texto", cellClass: "col-texto" },
        { text: "Status", value: "status", align: "center", width: "7%", minWidth: 90, class: "col-status", cellClass: "col-status" },
        { text: "A\u00e7\u00f5es", value: "actions", sortable: false, width: "9%", minWidth: 104, class: "col-acoes", cellClass: "col-acoes" },
      ];
    },
    headersCompactos() {
      return [
        { text: "OS", align: "start", value: "id", width: "7%", minWidth: 55, class: "col-os", cellClass: "col-os" },
        { text: "In\u00edcio", value: "dataInicial", width: "11%", minWidth: 86, class: "col-data", cellClass: "col-data" },
        { text: "Fim", value: "dataFinal", width: "11%", minWidth: 86, class: "col-data", cellClass: "col-data" },
        { text: "Unidade", value: "unidadeAdm", width: "20%", minWidth: 130, class: "col-texto", cellClass: "col-texto" },
        { text: "Equipamento", value: "equipamento", width: "24%", minWidth: 140, class: "col-texto", cellClass: "col-texto" },
        { text: "Status", value: "status", align: "center", width: "9%", minWidth: 90, class: "col-status", cellClass: "col-status" },
        { text: "A\u00e7\u00f5es", value: "actions", sortable: false, width: "12%", minWidth: 104, class: "col-acoes", cellClass: "col-acoes" },
      ];
    },
    headersAtuais() {
      return this.$vuetify.breakpoint.lgAndUp
        ? this.headersDesktop
        : this.headersCompactos;
    },
    isMobileLayout() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isTabelaCompacta() {
      return !this.$vuetify.breakpoint.lgAndUp && !this.isMobileLayout;
    },
    resizableColumnsOptions() {
      return {
        storageKey: this.isTabelaCompacta
          ? "salum:table-columns:ordem-servico-lista:compacta"
          : "salum:table-columns:ordem-servico-lista:desktop",
        columns: this.headersAtuais,
        resetKey: this.columnResizeResetKey,
      };
    },
    totalPaginasMobile() {
      if (this.options.itemsPerPage === -1) {
        return 1;
      }

      return Math.max(
        1,
        Math.ceil(this.filteredList.length / this.options.itemsPerPage)
      );
    },
    paginaMobileAtual() {
      return Math.min(this.options.page, this.totalPaginasMobile);
    },
    itemsPaginadosMobile() {
      if (this.options.itemsPerPage === -1) {
        return this.filteredList;
      }

      const inicio = (this.paginaMobileAtual - 1) * this.options.itemsPerPage;
      return this.filteredList.slice(inicio, inicio + this.options.itemsPerPage);
    },
    ...mapState("ordemServico", ["ordensServico"]),
    ...mapState("equipamento", ["equipamentos"]),
    ...mapState("local", ["locais"]),
    ...mapState("mecanico", ["mecanicos"]),
    ...mapState("localizacao", ["localizacoes"]),
    ...mapState("planoManutencao", ["planosManutencao"]),
    filteredList() {
      const searchLower = this.search.toLowerCase();

      return this.ordensServico
        .filter((os) => {
          const buscaTexto =
            os.id.toString().toLowerCase().includes(searchLower) ||
            os.unidadeAdm.toLowerCase().includes(searchLower) ||
            os.usuario.toLowerCase().includes(searchLower) ||
            os.equipamento.toLowerCase().includes(searchLower) ||
            this.formatarMecanico(os).toLowerCase().includes(searchLower) ||
            os.itens.some(
              (s) =>
                s.descricao?.toLowerCase().includes(searchLower)
            );

          // 2. Filtro por data (se datas forem preenchidas)
          const dataValida =
            !this.dataIni ||
            !this.dataFim ||
            (new Date(os.dataInicial.split("T")[0]) >=
              new Date(this.dataIni.split("T")[0]) &&
              new Date(os.dataInicial.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]));

          // 3. Filtros refinados (filters)
          const filtrosOk = Object.keys(this.filters).every((f) => {
            if (this.filters[f].length < 1) return true;

            if (["dataInicial", "dataFinal"].includes(f)) {
              const dataFormatada = this.formatarDataHora(os[f]);
              return this.filters[f].includes(dataFormatada);
            }

            if (f === "mecanico") {
              return this.filters[f].includes(this.formatarMecanico(os));
            }

            return this.filters[f].includes(os[f]);
          });

          // 4. Filtro por status (se não for "0")
          const statusOk =
            this.selectedFilter === "0" || os.status === this.selectedFilter;

          return buscaTexto && dataValida && filtrosOk && statusOk;
        })
        .sort((a, b) => b.id - a.id);
    },
    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
  },
  methods: {
    ...mapActions("ordemServico", [
      "atualizarOrdensServico",
      "atualizarOrdemServico",
      "updateOrdemServico",
    ]),
    ...mapActions("local", ["atualizarLocais"]),
    ...mapActions("equipamento", ["atualizarEquipamentos"]),
    ...mapActions("mecanico", ["atualizarMecanicos"]),
    ...mapActions("localizacao", ["atualizarLocalizacoes"]),
    ...mapActions("planoManutencao", ["atualizarPlanosManutencao"]),
    editar(ordemServico) {
      this.atualizarOrdemServico(ordemServico);
      if (this.isAllowed(this.idModulo)) {
        this.$router.push({
          path: "/ordemServico/editar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/ordemServico/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    baixarlista() {
      const blob = this.gerarExcel();
      const nome_arquivo = "ordensservico.xlsx";
      saveAs(blob, nome_arquivo);
    },
    restaurarColunasOrdemServico() {
      this.columnResizeResetKey += 1;
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarOrdensServico();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
    formatarValor(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return "-";
      }

      return valor;
    },
    formatarAtivo(ordemServico) {
      return ordemServico.ativo ? "Ativo" : "Inativo";
    },
    statusLabel(status) {
      return ["EA", "AA", "B", "D"].includes(status) ? status : "I";
    },
    statusColor(status) {
      const cores = {
        EA: "red",
        AA: "green",
        B: "grey darken-1",
        D: "grey darken-1",
        I: "blue-grey lighten-4",
      };

      return cores[status] || cores.I;
    },
    alternarDetalhesMobile(id) {
      this.detalhesMobileAbertos = this.detalhesMobileAbertos === id ? null : id;
    },
    alterarPaginaMobile(page) {
      this.options = { ...this.options, page };
    },
    alterarItensPorPagina(itemsPerPage) {
      this.options = { ...this.options, itemsPerPage, page: 1 };
    },
    formatarDataHora(data, hora) {
      const dataFormatada = this.formatarData(data);
      if (!dataFormatada) {
        return "";
      }

      const horaFormatada = this.formatarHora(hora || data);
      return horaFormatada ? `${dataFormatada} ${horaFormatada}` : dataFormatada;
    },
    formatarData(data) {
      if (!data) {
        return "";
      }

      if (data instanceof Date) {
        const dataFormatada = moment(data);
        return dataFormatada.isValid() ? dataFormatada.format("DD/MM/YYYY") : "";
      }

      const dataFormatada = moment(String(data), [moment.ISO_8601, "DD/MM/YYYY"], true);
      return dataFormatada.isValid() ? dataFormatada.format("DD/MM/YYYY") : "";
    },
    formatarHora(data) {
      if (!data) {
        return "";
      }

      if (data instanceof Date) {
        const horaFormatada = moment(data);
        return horaFormatada.isValid() ? horaFormatada.format("HH:mm") : "";
      }

      const valor = String(data);
      const horaFormatada = moment(valor, ["HH:mm:ss", "HH:mm"], true);
      if (horaFormatada.isValid()) {
        return horaFormatada.format("HH:mm");
      }

      if (!/[T\s]\d{2}:\d{2}/.test(valor)) {
        return "";
      }

      const dataFormatada = moment(valor, moment.ISO_8601, true);
      return dataFormatada.isValid() ? dataFormatada.format("HH:mm") : "";
    },
    formatarMecanico(ordemServico) {
      if (!ordemServico) {
        return "";
      }

      if (ordemServico.mecanico) {
        return ordemServico.mecanico;
      }

      const mecanico = this.mecanicos.find(
        (m) => m.id === ordemServico.idMecanico
      );

      return mecanico?.nome || "";
    },
    formatarTipoOS(tipoOS) {
      const tipos = {
        PV: "Preventiva",
        CR: "Corretiva",
        PD: "Preditiva",
      };

      return tipos[tipoOS] || tipoOS || "";
    },
    doAjax() {
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      if (!this.equipamentos || this.equipamentos.length == 0) {
        this.atualizarEquipamentos();
      }
      if (!this.mecanicos || this.mecanicos.length == 0) {
        this.atualizarMecanicos();
      }
      if (!this.localizacoes || this.localizacoes.length == 0) {
        this.atualizarLocalizacoes();
      }
      if (!this.planosManutencao || this.planosManutencao.length == 0) {
        this.atualizarPlanosManutencao();
      }
    },
    
    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },
    show(ordemServico) {
      getPdf(ordemServico.id, abrirJanelaPdf());
    },
    isInactive(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return canInactivateModule(id) || (regra != null && regra.inativar);
    },
    ordemServicoPodeSerInativada(ordemServico) {
      return !["B", "I"].includes(ordemServico.status);
    },
    inativar(ordemServico) {
      if (!this.ordemServicoPodeSerInativada(ordemServico)) {
        return;
      }

      this.item = ordemServico;
      this.justificativa = null;
      this.showModal = true;
    },
    fecharModal() {
      this.showModal = false;
      this.justificativa = null;
      if (this.$refs.form2) {
        this.$refs.form2.resetValidation();
      }
    },
    async realizarInativacao() {
      if (!this.$refs.form2.validate()) {
        return;
      }

      this.showModal = false;
      this.overlay = true;
      try {
        this.item.justificativa = this.justificativa;
        const resposta = await inativarOrdemServicoAsync(
          this.item.id,
          this.item.tipoOS,
          this.item.prioridade,
          this.item.idUnidadeAdm,
          this.item.idEquipamento,
          this.item.idPlanoManutencao,
          this.item.idPeriodicidade,
          this.item.idMecanico,
          this.item.idLubrificador,
          this.item.idEletricista,
          this.item.idLocalizacao,
          this.item.informacoesAdicionais,
          this.item.dataInicial,
          this.item.dataFinal,
          this.item.horaInicial,
          this.item.horaFinal,
          this.item.horimetroInicial,
          this.item.horimetroFinal,
          this.item.justificativa,
          this.item.itens
        );

        if (!resposta || resposta?.status != 200) {
          this.$alert(
            resposta.message,
            "Desculpe, falha na operação!",
            "error"
          );
        } else {
          this.$store.dispatch("ui/showSnackbar", {
            text: "Ordem de Serviço inativada!",
            color: "success",
            timeout: 3000,
          });
          this.item.status = "I";
          this.item.ativo = false;
          this.updateOrdemServico(this.item);
          await this.atualizarOrdensServico();
        }
      } finally {
        this.overlay = false;
        this.justificativa = null;
      }
    },
    
    gerarExcel() {
      const colunas = [
        { chave: "id", cabecalho: "OS" },
        { chave: "dataInicial", cabecalho: "Data Início" },
        { chave: "dataFinal", cabecalho: "Data Fim" },
        { chave: "tempo", cabecalho: "Tempo OS" },
        { chave: "unidadeAdm", cabecalho: "Unidade Adm" },
        { chave: "editor", cabecalho: "Responsável" },
        { chave: "tipoOS", cabecalho: "Tipo OS" },
        { chave: "equipamento", cabecalho: "Equipamento" },
        { chave: "status", cabecalho: "Status" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(
          colunas.map((c) => {
            if (c.chave === "dataInicial") {
              return this.formatarDataHora(item.dataInicial, item.horaInicial);
            } else if (c.chave === "dataFinal") {
              return this.formatarDataHora(item.dataFinal, item.horaFinal);
            } else if (c.chave === "id") {
              return item[c.chave] === 0 ? "" : item[c.chave];
            } else if (c.chave === "tipoOS") {
              return this.formatarTipoOS(item.tipoOS);
            } else if (c.chave === "editor") {
              return (item.editor || item.usuario);
            } else {
              return item[c.chave];
            }
          })
        );
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next };
        }
      },
    },
  },
  created: function () {
    const f = this.$route.query.selectedFilter;
    const allowed = ['0', 'EA', 'AA', 'B', 'I'];
    this.selectedFilter = allowed.includes(f) ? f : '0';
    this.obterLista();
    this.doAjax();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }

    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
};
</script>

<style scoped>
.ordem-servico-lista__titulo {
  align-items: center;
  flex-wrap: nowrap;
}

.ordem-servico-lista__titulo .v-input {
  min-width: 220px;
}

.ordem-servico-lista__restaurar-colunas {
  flex: 0 0 auto;
  text-transform: none;
}

.ordem-servico-table {
  width: 100%;
}

.ordem-servico-table ::v-deep table {
  width: 100%;
  table-layout: auto;
}

.ordem-servico-table ::v-deep th,
.ordem-servico-table ::v-deep td {
  padding-left: 6px !important;
  padding-right: 6px !important;
  vertical-align: top;
  word-break: normal;
}

.ordem-servico-table ::v-deep th {
  line-height: 1.2;
}
.os-data-hora {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  white-space: nowrap;
}

.os-data,
.os-hora {
  display: block;
  white-space: nowrap;
}

.ordem-servico-table ::v-deep th.col-os,
.ordem-servico-table ::v-deep td.col-os,
.ordem-servico-table ::v-deep th.col-chamado,
.ordem-servico-table ::v-deep td.col-chamado,
.ordem-servico-table ::v-deep th.col-data,
.ordem-servico-table ::v-deep td.col-data,
.ordem-servico-table ::v-deep th.col-tempo,
.ordem-servico-table ::v-deep td.col-tempo,
.ordem-servico-table ::v-deep th.col-status,
.ordem-servico-table ::v-deep td.col-status,
.ordem-servico-table ::v-deep th.col-acoes,
.ordem-servico-table ::v-deep td.col-acoes,
.cell-nowrap,
.status-cell,
.acoes-cell {
  white-space: nowrap;
  word-break: normal;
  overflow-wrap: normal;
}

.ordem-servico-table ::v-deep th.col-texto,
.ordem-servico-table ::v-deep td.col-texto,
.cell-texto,
.os-detail-item strong,
.os-mobile-field strong {
  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;
}

.status-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.acoes-cell {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
}

.acoes-cell .v-icon {
  flex: 0 0 auto;
  margin-right: 0 !important;
}

.os-expanded-cell {
  background: #fafafa;
}

.os-expanded-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px 18px;
  padding: 12px 8px;
}

.os-detail-item {
  min-width: 0;
}

.os-detail-item span,
.os-mobile-field span,
.os-mobile-title span {
  color: rgba(0, 0, 0, 0.6);
  display: block;
  font-size: 0.78rem;
  line-height: 1.2;
}

.os-detail-item strong,
.os-mobile-field strong,
.os-mobile-title strong {
  color: rgba(0, 0, 0, 0.87);
  display: block;
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.25;
  min-width: 0;
}

.os-mobile-list {
  display: grid;
  gap: 12px;
  padding: 0 12px 12px;
  width: 100%;
}

.os-mobile-card {
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.os-mobile-card__header {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 12px 14px 8px;
}

.os-mobile-title,
.os-mobile-status {
  min-width: 0;
}

.os-mobile-title strong {
  font-size: 1.15rem;
}

.os-mobile-status {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 6px;
  white-space: nowrap;
}

.os-mobile-body {
  display: grid;
  gap: 8px;
  padding: 8px 14px 12px !important;
}

.os-mobile-field {
  display: grid;
  gap: 8px;
  grid-template-columns: 92px minmax(0, 1fr);
  min-width: 0;
}

.os-mobile-details-btn {
  justify-self: start;
  margin-left: -8px;
}

.os-mobile-details {
  display: grid;
  gap: 8px;
  padding-top: 4px;
}

.os-mobile-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 10px 10px;
}

.os-mobile-actions .v-btn {
  min-height: 36px;
}

.os-mobile-empty {
  color: rgba(0, 0, 0, 0.6);
  padding: 20px 8px;
  text-align: center;
}

.os-mobile-pagination {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  padding-top: 2px;
}

.os-mobile-per-page {
  flex: 0 0 150px;
}

@media (max-width: 420px) {
  .os-mobile-list {
    padding-left: 8px;
    padding-right: 8px;
  }

  .os-mobile-field {
    grid-template-columns: 78px minmax(0, 1fr);
  }

  .os-mobile-card__header {
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
